import React, { useState, useContext } from 'react';
import backstep_icon from 'images/backstep_icon.svg';
import cloneDeep from 'lodash/cloneDeep';
import { ItemTypes } from '../ItemTypes';
import KeyboardButton from './KeyboardButton';
import { TransformContext } from '../TransformContext';

const KEY_RAW_STYLE = {
    display: 'flex',
    flexDirection: 'row'
};

const NumericalKeyboard = () => {
    let tContext = useContext(TransformContext);

    const handleStepBack = () => {
        const prevState = tContext.getFormulaHistory();
        tContext.setFormulaItems(prevState);
    };

    const handleClearAll = () => {
        tContext.setFormulaItems([]);
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ marginRight: 10 }}>
                    <div style={KEY_RAW_STYLE}>
                        <KeyboardButton button="seven" />

                        <KeyboardButton button="eight" />
                        <KeyboardButton button="nine" />
                        <KeyboardButton button="plus" />
                        <KeyboardButton button="multiplier" />
                        <KeyboardButton button="divider" />
                    </div>
                    <div style={KEY_RAW_STYLE}>
                        <KeyboardButton button="four" />
                        <KeyboardButton button="five" />
                        <KeyboardButton button="six" />
                        <KeyboardButton button="minus" />
                        <KeyboardButton button="parenthesisLeft" />
                        <KeyboardButton button="parenthesisRight" />
                    </div>
                    <div style={KEY_RAW_STYLE}>
                        <KeyboardButton button="one" />
                        <KeyboardButton button="two" />
                        <KeyboardButton button="three" />
                        <div
                            className="calculator-left-side-button-custom"
                            onClick={() => {
                                handleStepBack();
                            }}
                            style={{ width: 112 }}
                        >
                            <span>UNDO</span>
                        </div>
                    </div>

                    <div style={KEY_RAW_STYLE}>
                        <KeyboardButton buttonWidth={73} button="zero" />
                        <KeyboardButton button="dot" />
                        <div
                            className="calculator-left-side-button-custom"
                            onClick={() => {
                                handleClearAll();
                            }}
                            style={{ width: 112 }}
                        >
                            <span>CLEAR ALL</span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                style={{ display: 'flex', flexDirection: 'row', marginTop: 17 }}
            >
                <div>
                    <div style={KEY_RAW_STYLE}>
                        <KeyboardButton side="right" button="sqrt" />
                        <KeyboardButton side="right" button="lag" />
                        <KeyboardButton side="right" button="ln" />
                        <KeyboardButton side="right" button="exp" />
                        <KeyboardButton side="right" button="pow2" />
                        <KeyboardButton side="right" button="pow3" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default NumericalKeyboard;
